const ALLOWED_TAGS = ['br', 'p', 'a', 'b', 'strong', 'i', 'em', 'span'];

const ALLOWED_ATTRIBUTES: { [tag: string]: string[] } = {
  a: ['href'],
};

export default class HtmlSanitizer {
  public static sanitize(html: string): string {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    HtmlSanitizer.sanitizeChildren(template.content);
    return template.innerHTML;
  }

  private static sanitizeChildren(parent: Node): void {
    Array.from(parent.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) {
        parent.removeChild(node);
        return;
      }
      const element = node as HTMLElement;
      HtmlSanitizer.sanitizeChildren(element);
      const tag = element.tagName.toLowerCase();
      if (!ALLOWED_TAGS.includes(tag)) {
        while (element.firstChild) {
          parent.insertBefore(element.firstChild, element);
        }
        parent.removeChild(element);
        return;
      }
      HtmlSanitizer.sanitizeAttributes(element, tag);
    });
  }

  private static sanitizeAttributes(element: HTMLElement, tag: string): void {
    const allowed = ALLOWED_ATTRIBUTES[tag] || [];
    Array.from(element.attributes).forEach((attribute) => {
      if (!allowed.includes(attribute.name)) {
        element.removeAttribute(attribute.name);
      }
    });
    if (tag === 'a') {
      const href = element.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(href.trim())) {
        element.removeAttribute('href');
      }
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener noreferrer');
    }
  }
}
